import { API } from '~/data/api'
import { GeoLocationInfo } from '~/types/geolocation'
import {
  useSessionStorageService,
  SESSION_STORAGE_KEYS
} from '~/composables/useSessionStorageService'

export interface GeoCodeItem {
  text: string
  magicKey: string
}

export interface GeoSuggestionData {
  latitude?: number
  longitude?: number
  q?: string
  limit?: number
  lang?: string
}

export const useGeoService = () => {
  const { setItem, getItem } = useSessionStorageService()

  async function geoCode(item: GeoCodeItem) {
    const response = await API.geoCode(item)
    return response?.data
  }

  async function getSuggestions(data: GeoSuggestionData) {
    const response = await API.getGeoSuggestions(data)
    return response.data
  }

  async function reverseGeoCode(data: GeoSuggestionData) {
    const response = await API.reverseGeoCode(data)
    return response.data
  }

  async function leaveChallenge(id: string) {
    const response = await API.leaveChallenge(id)
    return response.data
  }

  async function getGeoIP(): Promise<GeoLocationInfo | undefined | null> {
    const storedLocation = getItem(SESSION_STORAGE_KEYS.geoIpInfo)

    if (storedLocation) {
      return JSON.parse(storedLocation) as GeoLocationInfo
    }

    const response = await API.getLocation()
    const data = response.data

    if (data != null) {
      setItem(SESSION_STORAGE_KEYS.geoIpInfo, JSON.stringify(data))
    }

    return data
  }

  return {
    geoCode,
    getSuggestions,
    reverseGeoCode,
    leaveChallenge,
    getGeoIP
  }
}
